export default "__VITE_ASSET__C23REdS8__"